import { useRef } from 'react';

import { useGlobalStore } from '../state/globalStore';
import { Notification } from '../state/notificationStore';

export const useNotification = () => {
  const { showNotification, clearNotification } = useGlobalStore((store) => store);
  const notificationTimeout = useRef(0);
  return {
    show: (notification: Notification) => {
      clearTimeout(notificationTimeout.current);
      showNotification(notification);
      notificationTimeout.current = setTimeout(() => {
        clearNotification();
      }, notification.timeout || 2000);
    },
  };
};
